import { useParams } from "react-router-dom";
import { usePessoa } from "@/api/consultas";
import { useSessao } from "@/sessao/useSessao";

/**
 * O cedente do caminho, para a página e para qualquer aba abaixo de `/cedentes/:id`.
 *
 * Mesma consulta da página: nenhuma requisição a mais, e toda aba lê a mesma prontidão.
 * `pessoa` é `undefined` enquanto carrega, ou quando a leitura falhou. Quem trata o
 * `404` é a página: abaixo dela, a aba só precisa do `id`, que vem pronto.
 *
 * `prontidao` é `undefined` com qualquer erro: depois de uma escrita a consulta refaz a
 * leitura, e se ela falhar o cache continua com o retrato antigo.
 */
export function useCedenteDaRota() {
  const { id } = useParams();
  if (id === undefined) throw new Error("useCedenteDaRota fora de /cedentes/:id");

  const { cliente } = useSessao();
  const consulta = usePessoa(cliente, id);

  const prontidao = consulta.error === null ? consulta.data?.prontidao : undefined;

  return { id, pessoa: consulta.data, prontidao, consulta };
}
